// API Configuration - Centralized location for all API endpoints
// This file handles environment-based configuration for easy deployment

// Environment-based configuration
const getApiBaseUrl = () => {
  // Check if we're in development, staging, or production
  const hostname = window.location.hostname;

  // Environment detection based on your specific URLs
  const isDevelopmentLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  const isDevelopmentS3 = hostname === 'gv-crm-gc-web-app.s3-website.ap-south-1.amazonaws.com';
  const isCloudFront = hostname.includes('cloudfront.net');
  const isTestDomain = hostname === 'test.gadchirolicollector-nivedan.in' || hostname === 'api.test.gadchirolicollector-nivedan.in';
  const isProductionDomain = hostname === 'gadchirolicollector-nivedan.in' || hostname === 'www.gadchirolicollector-nivedan.in';

  // Runtime environment detection
  if (isProductionDomain) {
    // Production environment - runtime detection
    return 'https://api.gadchirolicollector-nivedan.in/api';
  } else if (isDevelopmentLocal) {
    // Local development environment - use .env file or fallback to test
    return process.env.REACT_APP_API_BASE_URL || 'https://api.test.gadchirolicollector-nivedan.in/api';
  } else if (isDevelopmentS3 || isTestDomain || isCloudFront) {
    // AWS S3 / CloudFront / Test domain environment - runtime detection
    return 'https://api.test.gadchirolicollector-nivedan.in/api';
  } else {
    // Fallback for any other domain - default to test API
    return 'https://api.test.gadchirolicollector-nivedan.in/api';
  }
};

// API Configuration Object
const API_CONFIG = {
  // Base URLs
  BASE_URL: getApiBaseUrl(),

  // File/Media Base URL (without /api)
  MEDIA_BASE_URL: getApiBaseUrl().replace('/api', ''),

  // Specific endpoint configurations
  ENDPOINTS: {
    // Authentication
    AUTH: {
      LOGIN: '/auth/login',
      RESET_PASSWORD: '/auth/reset-password',
    },

    // Complaints
    COMPLAINTS: {
      BASE: '/complaints',
      TRACK: '/complaints/track',
      ASSIGN: '/complaints/{id}/assign',
      STATUS: '/complaints/{id}/status',
      COMMENTS: '/complaints/{id}/comments',
      RATING: '/complaints/{id}/rating',
    },

    // Admin
    ADMIN: {
      BASE: '/admin',
      OFFICERS: '/admin/officers',
      ANALYTICS: '/admin/analytics/dashboard',
    },

    // Dashboard
    DASHBOARD: {
      STATS: '/dashboard/stats',
      USER_STATS: '/dashboard/user-stats',
    },

    // Departments
    DEPARTMENTS: '/departments',

    // Locations
    LOCATIONS: '/locations',

    // Files
    FILES: {
      UPLOAD: '/files/upload',
      ATTACHMENTS: '/files/attachments/{id}/image',
    },

    // Reports
    REPORTS: {
      PDF: '/reports/complaints/pdf',
      EXCEL: '/reports/complaints/excel',
    },

    // Translation
    TRANSLATE: '/translate',

    // Visitors Counter
    VISITORS: '/v1/global/visitors',

    // Bhashini Speech-to-Text
    BHASHINI_STT: '/bhashini/speech-to-text',
    BHASHINI_STT_EN: '/bhashini/speech-to-text1',
    BHASHINI_STT_MR: '/bhashini/speech-to-text',
  },
};

// Helper functions
export const getFullUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

export const getMediaUrl = (path) => {
  return `${API_CONFIG.MEDIA_BASE_URL}${path}`;
};

export const replaceUrlParams = (endpoint, params) => {
  let url = endpoint;
  Object.keys(params).forEach((key) => {
    url = url.replace(`{${key}}`, params[key]);
  });
  return url;
};

// Export getApiBaseUrl for use in components
export { getApiBaseUrl };

// Export the configuration
export default API_CONFIG;

// Environment info for debugging
export const ENV_INFO = {
  hostname: window.location.hostname,
  fullUrl: window.location.href,
  protocol: window.location.protocol,
  isDevelopmentLocal: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1',
  isDevelopmentS3: window.location.hostname === 'gv-crm-gc-web-app.s3-website.ap-south-1.amazonaws.com',
  isCloudFront: window.location.hostname.includes('cloudfront.net'),
  isTestDomain: window.location.hostname === 'test.gadchirolicollector-nivedan.in' || window.location.hostname === 'api.test.gadchirolicollector-nivedan.in',
  isProductionDomain: window.location.hostname === 'gadchirolicollector-nivedan.in' || window.location.hostname === 'www.gadchirolicollector-nivedan.in',
  detectedEnvironment: (() => {
    const hostname = window.location.hostname;
    if (hostname === 'gadchirolicollector-nivedan.in' || hostname === 'www.gadchirolicollector-nivedan.in') return 'production';
    if (hostname === 'localhost' || hostname === '127.0.0.1') return 'local-development';
    if (hostname === 'gv-crm-gc-web-app.s3-website.ap-south-1.amazonaws.com') return 'development';
    if (hostname.includes('cloudfront.net') || hostname === 'test.gadchirolicollector-nivedan.in' || hostname === 'api.test.gadchirolicollector-nivedan.in') return 'test';
    return 'unknown';
  })(),
  baseUrl: API_CONFIG.BASE_URL,
  mediaBaseUrl: API_CONFIG.MEDIA_BASE_URL,
};


